import { useNavigate } from "react-router-dom";

const FeaturedTrips = () => {
    const navigate = useNavigate();

    const featuredTrips = [
        {
            id: 1,
            title: "Saturday City Tour",
            description:
                "Explore Bangalore's iconic landmarks and hidden gems on our exciting Saturday city tour.",
            image: "/assets/city.jpg",
            day: "Saturday",
        },
        {
            id: 2,
            title: "Sunday Adventure",
            description:
                "Experience thrilling outdoor activities and scenic beauty on our Sunday adventure trips.",
            image: "/assets/adventure.jpg",
            day: "Sunday",
        },
    ];

    const handleSeeDetails = (trip) => {
        if (trip.day === "Saturday") {
            navigate("/trips");
        } else if (trip.day === "Sunday") {
            navigate("/trips");
        }
    };

    const handleSeeAllTrips = () => {
        navigate("/trips");
    };

    return (
        <div className="py-16 bg-gradient-to-br from-blue-50 to-purple-50">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">
                   <span className="text-indigo-600">Featured</span>  Weekend Trips
                </h2>
                <div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                        {featuredTrips.map((trip) => (
                            <div
                                key={trip.id}
                                className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300"
                            >
                                <img
                                    src={trip.image}
                                    alt={trip.title}
                                    className="w-full h-48 object-cover"
                                />
                                <div className="p-6">
                                    <div className="flex items-center justify-between mb-2">
                                        <h3 className="text-xl font-semibold text-gray-800">
                                            {trip.title}
                                        </h3>
                                        <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium">
                                            {trip.day}
                                        </span>
                                    </div>
                                    <p className="text-gray-600 mb-4">
                                        {trip.description}
                                    </p>
                                    <button
                                        onClick={() => handleSeeDetails(trip)}
                                        className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-2 px-4 rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all"
                                    >
                                        See Details
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div>
                        <button
                            onClick={handleSeeAllTrips}
                            className="mt-12 mx-auto block bg-gradient-to-r from-indigo-600 to-purple-600
                             text-white px-10 py-2 rounded-[12px] text-lg font-medium hover:opacity-90"
                        >
                         All Trips
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturedTrips;
